import { Row, Button } from "antd";
import React, { useEffect, useState } from "react";
import MorningSkincareRoutine from "../homeStore/morningSkincareRoutine";
import NightSkincareRoutine from "../homeStore/nightSkincareRoutine";
import AdditionalSkincareNotes from "../homeStore/additionalSkincareNotes";
import ThankYou from "../homeStore/thankyou";
import CurrentSkincareComponent from "../dashboard/sections/currentSkincare";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import { log } from "console";
import { getFirstName } from "../../utils/helper.util";
import { useAppSelector } from "../../hooks/reduxHooks";

interface HowToUseComponentInterface {
  data?: any;
  currentSkincare?: any;
}

const HowToUseComponent: React.FC<HowToUseComponentInterface> = ({
  data,
  currentSkincare,
}) => {
  const [response, setResponse] = useState<any>(null);
  const [additionalNotes, setAdditionalNotes] = useState<any>(null);

  const capitalize = (s: string) => s?.charAt(0).toUpperCase() + s?.slice(1);

  useEffect(() => {
    if (data?.response) {
      let parsedResponse: any = null;
      let parseNotes: any = null;

      try {
        // If it's already an object, no need to parse
        parsedResponse =
          typeof data.response?.suggested_products === "string"
            ? JSON.parse(data.response.suggested_products)
            : data.response.suggested_products;

        // If it's already an object, no need to parse
        parseNotes =
          typeof data.response?.additional_notes === "string"
            ? JSON.parse(data.response.additional_notes)
            : data.response.additional_notes;

        setResponse(parsedResponse ?? null);
        setAdditionalNotes(parseNotes ?? null);
      } catch (error) {
        console.error("Failed to parse response:", error);
      }
    }
  }, [data]);

  const navigate = useNavigate();

  const currMorningProducts = _.filter(currentSkincare?.morning, [
    "user_product",
    true,
  ]);

  const currNightProducts = _.filter(currentSkincare?.night, [
    "user_product",
    true,
  ]);

  const currentSkincareProducts = _.concat(
    currMorningProducts,
    currNightProducts
  );

  const dontUseProducts = _.filter(currentSkincareProducts, ["dont_use", true]);
  const keepUsingProducts = _.filter(currentSkincareProducts, [
    "dont_use",
    false,
  ]);

  const uniDontUseProducts = _.reduce(
    dontUseProducts,
    (res: any, row: any) => {
      let el = _.find(res, (el: any) => {
        return (
          // el["category_id"] === row["category_id"] &&
          el["brand_name"].toLowerCase() === row["brand_name"].toLowerCase() &&
          el["name"].toLowerCase() === row["name"].toLowerCase()
        );
      });

      if (el) {
        el["note"] = [el["note"], row["note"]];
      } else {
        res.push({ ...row });
      }
      return res;
    },
    []
  );

  const uniKeepUsingProducts = _.reduce(
    keepUsingProducts,
    (res: any, row: any) => {
      let el = _.find(res, (el: any) => {
        return (
          // el["category_id"] === row["category_id"] &&
          el["brand_name"].toLowerCase() === row["brand_name"].toLowerCase() &&
          el["name"].toLowerCase() === row["name"].toLowerCase()
        );
      });

      if (el) {
        el["note"] = [el["note"], row["note"]];
      } else {
        res.push({ ...row });
      }
      return res;
    },
    []
  );
  const state = useAppSelector((state) => state);
  const { userData }: { userData?: any } = state.profile;
// console.log("survey_type:", data?.survey_type);

  return (
    <section className="store-section how-to-use-section">
      <div className="home-store home-store__how-to-use">
        
        <MorningSkincareRoutine
          data={response?.morning}
          userName={getFirstName(userData?.name) ?? ""}
          capitalize={capitalize}
          type={data?.survey_type} 
        />

        <NightSkincareRoutine
          data={response?.night}
          userName={getFirstName(userData?.name) ?? ""}
          capitalize={capitalize}
          type={data?.survey_type}
        />

        <AdditionalSkincareNotes data={additionalNotes} />

        {uniKeepUsingProducts.length > 0 || uniDontUseProducts.length > 0 ? (
          <div className="skin-profile">
            <CurrentSkincareComponent
              keepUsing={uniKeepUsingProducts}
              dontUse={uniDontUseProducts}
            />
          </div>
        ) : null}
      </div>
      <div className="footer-cta">
        <Button
          className="btn-primary cta-btn"
          onClick={() => {
            navigate("/store/where-to-buy");
            ReactGA.event({
              category: "Store",
              action: `Go to Skincare Steps button clicked`,
              label: "",
              nonInteraction: true, // optional, true/false
              transport: "xhr",
            });
          }}
        >
          Go to Where to Buy
        </Button>
      </div>

    </section>
  );
};

export default HowToUseComponent;
